import * as actionTypes from 'containers/AccessControl/actionTypes';
import { HamburgerMenuType, PeriodEndWeekType } from 'utils/types';

export type StateType = {
  readonly expirationDateTime: string;
  readonly hamburgerMenuItems: Array<HamburgerMenuType>;
  readonly periodEndWeek: PeriodEndWeekType;
};

export const initialState: StateType = {
  expirationDateTime: null,
  hamburgerMenuItems: [],
  periodEndWeek: null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.HAMBURGER_MENU_ITEMS_SET:
      return { ...state, hamburgerMenuItems: payload };
    case actionTypes.PERIOD_DATE_SET:
      return {
        ...state,
        periodEndWeek: {
          spins: payload.spins ? payload.spins : null,
          nielsen: payload.nielsen ? payload.nielsen : null
        }
      };
    default:
      return state;
  }
};
